import React from 'react';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RefreshIcon from '@mui/icons-material/Refresh';
import RadarIcon from '@mui/icons-material/Radar';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';

export default function PreparationHeader({
  t,
  scoreDate,
  exportingImage,
  candidatesCount,
  refreshInFlight,
  loading,
  onExportTable,
  onTriggerRefresh,
  onReload,
}) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.1, minWidth: 0, flex: '1 1 280px' }}>
        <Box sx={{
          width: 38,
          height: 38,
          borderRadius: 1.25,
          flexShrink: 0,
          background: 'linear-gradient(135deg, #7c3aed 0%, #2563eb 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 3px 10px rgba(99, 102, 241, 0.2)',
        }}>
          <HourglassEmptyIcon sx={{ fontSize: 20, color: '#fff' }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.85, flexWrap: 'wrap' }}>
            <Typography sx={{ fontSize: { xs: '1.05rem', sm: '1.15rem' }, fontWeight: 800, color: '#1e293b', letterSpacing: -0.2, lineHeight: 1.15 }}>
              {t('preparation.pageTitle')}
            </Typography>
            {scoreDate && (
              <Chip
                size="small"
                label={scoreDate}
                sx={{ height: 22, fontWeight: 700, fontSize: '0.68rem', bgcolor: '#f1f5f9', color: '#475569' }}
              />
            )}
          </Box>
          <Typography sx={{ fontSize: '0.72rem', color: '#94a3b8', mt: 0.2, lineHeight: 1.35, maxWidth: 720 }}>
            {t('preparation.pageDesc')}
          </Typography>
        </Box>
      </Box>
      <Stack direction="row" spacing={0.75} alignItems="center" data-html2canvas-ignore="true">
        <Button
          variant="outlined"
          size="small"
          startIcon={exportingImage ? <CircularProgress size={14} /> : <DownloadRoundedIcon sx={{ fontSize: 16 }} />}
          onClick={onExportTable}
          disabled={exportingImage || candidatesCount === 0}
          sx={{ textTransform: 'none', fontSize: 12.5, fontWeight: 600, borderColor: '#e2e8f0', color: '#475569' }}
        >
          {exportingImage ? t('preparation.table.exportingImage') : t('preparation.table.exportImage')}
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={refreshInFlight ? <CircularProgress size={14} /> : <RadarIcon sx={{ fontSize: 16 }} />}
          onClick={onTriggerRefresh}
          disabled={refreshInFlight}
          sx={{ textTransform: 'none', fontSize: 12.5, fontWeight: 600, borderColor: '#e2e8f0', color: '#475569' }}
        >
          {refreshInFlight ? t('preparation.refresh.runningButton') : t('preparation.refresh.button')}
        </Button>
        <Button
          variant="contained"
          size="small"
          startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <RefreshIcon sx={{ fontSize: 16 }} />}
          onClick={onReload}
          disabled={loading}
          sx={{ textTransform: 'none', fontSize: 12.5, fontWeight: 700, bgcolor: '#7c3aed', boxShadow: 'none', '&:hover': { bgcolor: '#6d28d9', boxShadow: 'none' } }}
        >
          {t('common.refresh')}
        </Button>
      </Stack>
    </Box>
  );
}
